import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDoVEpFa8UzCW2fi5IrUdsBvQmS5-_uN5Y",
  authDomain: "bertocproject-gestionale.firebaseapp.com",
  projectId: "bertocproject-gestionale",
  storageBucket: "bertocproject-gestionale.firebasestorage.app",
  messagingSenderId: "139127521647",
  appId: "1:139127521647:web:cdde6e9a4cbe20fceb689a"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Abilita persistenza offline — i dati vengono salvati localmente
// e sincronizzati automaticamente quando torna la connessione
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    console.warn("Offline persistence disponibile solo in una scheda alla volta");
  } else if (err.code === "unimplemented") {
    console.warn("Questo browser non supporta la persistenza offline");
  }
});
